// src/resources/entityReports/helpers.js

export const formatTypeLabel = (type) => {
    switch (type) {
        case 'SUBJECT':
            return 'Sujet';
        case 'OOBJECT':
            return 'Objet';
        case 'RDF':
        default:
            return 'RDF';
    }
};

export const getEntityTitle = (record = {}) => {
    if (record.type === 'SUBJECT' && record.subject) {
        return record.subject.subject || record.subject.shortSubject || 'Sujet';
    }
    if (record.type === 'OOBJECT' && record.oobject) {
        return record.oobject.oobject || record.oobject.shortOobject || 'Objet';
    }
    if (record.rdf) {
        if (record.rdf.slug) return record.rdf.slug;
        const parts = [record.rdf.subjectLabel, record.rdf.predicateLabel, record.rdf.oobjectLabel]
            .filter(Boolean)
            .join(' · ');
        return parts || 'RDF';
    }
    return record.id || '—';
};

export const getEntitySubtitle = (record = {}) => {
    if (record.type === 'SUBJECT' && record.subject) {
        return record.subject.shortSubject || record.subject.subject || null;
    }
    if (record.type === 'OOBJECT' && record.oobject) {
        return record.oobject.shortOobject || record.oobject.oobject || null;
    }
    if (record.rdf) {
        const segments = [record.rdf.subjectLabel, record.rdf.predicateLabel, record.rdf.oobjectLabel]
            .filter(Boolean);
        return segments.length ? segments.join(' · ') : record.rdf.slug || null;
    }
    return null;
};

export const getReporterList = (record = {}) => {
    return Array.isArray(record.reporters)
        ? record.reporters.filter(Boolean)
        : [];
};

export const getReasonStats = (record = {}) => {
    return Array.isArray(record.reasonStats)
        ? record.reasonStats.filter(Boolean)
        : [];
};

export const getLatestReports = (record = {}) => {
    return Array.isArray(record.latestReports)
        ? record.latestReports.filter(Boolean)
        : [];
};
